var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconArrowUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "arrow_drop_up"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3524_3856",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3524_3856)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "arrow_drop_up_2",
    d: "M8.19922 13.9998C8.04922 13.9998 7.92839 13.9498 7.83672 13.8498C7.74505 13.7498 7.69922 13.6331 7.69922 13.4998C7.69922 13.4665 7.74922 13.3498 7.84922 13.1498L11.4742 9.5248C11.5576 9.44147 11.6409 9.38314 11.7242 9.3498C11.8076 9.31647 11.8992 9.2998 11.9992 9.2998C12.0992 9.2998 12.1909 9.31647 12.2742 9.3498C12.3576 9.38314 12.4409 9.44147 12.5242 9.5248L16.1492 13.1498C16.1992 13.1998 16.2367 13.254 16.2617 13.3123C16.2867 13.3706 16.2992 13.4331 16.2992 13.4998C16.2992 13.6331 16.2534 13.7498 16.1617 13.8498C16.0701 13.9498 15.9492 13.9998 15.7992 13.9998H8.19922Z",
    fill: "#848C98"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArrowUp);
export default __webpack_public_path__ + "static/media/icon_arrow_up.5f07701b023471225be013d19d9b5ec3.svg";
export { ForwardRef as ReactComponent };